import { render, staticRenderFns } from "./ActualizacionDocumentos.vue?vue&type=template&id=de84c1bc&scoped=true"
import script from "./ActualizacionDocumentos.vue?vue&type=script&lang=js"
export * from "./ActualizacionDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de84c1bc",
  null
  
)

export default component.exports